// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__ZJHiU","upload":"Small_upload__3oNu_","imageWrap":"Small_imageWrap__1eG3Y","removeBtn":"Small_removeBtn__29UW4"};